import React, { useEffect, useState } from "react";
import classnames from "classnames";
import styles from "./TurnrModal.module.scss";
import { COLORS } from "rylak-common/src/constants";
import _ from "lodash";
import IconButtonClose from "../buttons/icon-buttons/IconButtonClose";
import IconButtonBack from "../buttons/icon-buttons/IconButtonBack";
import { TurnrPortal } from "../portal/TurnrPortal";

// import { interFont } from "../../apps/fonts";

export function TurnrModalTitle({ children }) {
    return (
        <h2
            className={"modal-title"}
            style={{
                fontSize: "18px",
                // fontFamily: interFont.style.fontFamily,
                margin: "25px 25px 15px 25px",
                marginRight: "40px",
                display: "flex",
            }}
        >
            {children}
        </h2>
    );
}

export function TurnrModalDescription({ children }) {
    return (
        <TurnrModalContent
            style={{
                color: COLORS.SLIGHTLY_WEAK_TEXT,
                fontSize: "12px",
                maxWidth: "650px",
                lineHeight: 1.5,
                marginTop: "15px",
            }}
            fontSize={"10px"}
        >
            {children}
        </TurnrModalContent>
    );
}

const sizeToMargin = {
    small: "16px",
    medium: "25px",
};

export function TurnrModalHeader({ onBack, onClose, title }) {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "10px 10px",
            }}
        >
            <div>
                {(onBack || onClose) && (
                    <div style={{ visibility: !onBack && "hidden" }} className={styles["back-button"]} onClick={onBack}>
                        <IconButtonBack onClick={onBack} />
                    </div>
                )}
            </div>
            <div className={styles["header-title"]} style={{ fontWeight: 400 }}>
                {title}
            </div>
            {(onBack || onClose) && (
                <div style={{ visibility: !onClose && "hidden" }} className={styles["close-button"]}>
                    <IconButtonClose onClick={onClose} className={styles["close-icon"]} width={"30%"} />
                </div>
            )}
        </div>
    );
}

export function TurnrModalContent({ style, className, size = "medium", children }) {
    return (
        <div className={className} style={{ margin: sizeToMargin[size], ...style }}>
            {children}
        </div>
    );
}

export function TurnrModalContainer({ children, title, description, style, className }) {
    return (
        <div style={style} className={className}>
            {title && <TurnrModalTitle>{title}</TurnrModalTitle>}
            {description && <TurnrModalDescription>{description}</TurnrModalDescription>}
            {children}
        </div>
    );
}

export default function TurnrModal(props) {
    const { children, onClose, open, title, description, style, className } = props;
    useEffect(() => {
        // We use a timeout because of a bug with background-filter: blur() in the shop styling
        setTimeout(() => {
            // This is to avoid background scroll behaviour in mobile view when the modal is active
            if (open) {
                const scrollY = window.scrollY;
                document.body.style.height = "initial";
                document.body.style.top = `-${scrollY}px`;
                document.body.style.position = "fixed";
                document.getElementsByTagName("html")[0].style.height = "100dvh";
            } else {
                const scrollY = document.body.style.top;
                document.body.style.position = "";
                document.body.style.top = "";
                document.body.style.height = "initial";
                document.getElementsByTagName("html")[0].style.height = "";
                window.scrollTo(0, parseInt(scrollY || "0") * -1);
            }
        }, 1);
        return () => {
            const scrollY = document.body.style.top;
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.height = "initial";
            document.getElementsByTagName("html")[0].style.height = "";
            window.scrollTo(0, parseInt(scrollY || "0") * -1);
        };
    }, [open]);

    function onCloseClick(e) {
        e.stopPropagation();
        onClose(false);
    }

    const [modalContentResetKey, setModalContentResetKey] = useState(_.uniqueId());

    useEffect(() => {
        if (open) {
            // We want content to always fully rerender everytime the modal opens
            setModalContentResetKey(_.uniqueId());
        }
    }, [open]);

    return (
        <TurnrPortal open={open}>
            <div className={classnames(styles["modal-background-colored"], open && styles["in"], !open && styles["out"])} />
            <div
                className={classnames(styles["modal-container"], styles["two"], open && styles["in"], !open && styles["out"])}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className={styles["modal-background-click-part"]} onMouseDown={onCloseClick}>
                    <div
                        style={style}
                        className={classnames(styles["modal"], className)}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div>
                            <TurnrModalContainer title={title} description={description}>
                                <React.Fragment key={modalContentResetKey}>{children}</React.Fragment>
                            </TurnrModalContainer>
                        </div>
                    </div>
                </div>
            </div>
        </TurnrPortal>
    );
}
